import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { AccessibleViewService } from 'vscode/vscode/vs/workbench/contrib/accessibility/browser/accessibleView';
import { AccessibilitySignalService } from 'vscode/vscode/vs/platform/accessibilitySignal/browser/accessibilitySignalService';
import audioAssets from './vscode/src/vs/platform/accessibilitySignal/browser/media/all.mp3.js';
import { IAccessibleViewService } from 'vscode/vscode/vs/workbench/contrib/accessibility/browser/accessibleView.service';
import { IAccessibilitySignalService } from 'vscode/vscode/vs/platform/accessibilitySignal/browser/accessibilitySignalService.service';
import { IAccessibleViewInformationService } from 'vscode/vscode/vs/workbench/services/accessibility/common/accessibleViewInformationService.service';
import { AccessibleViewInformationService } from './vscode/src/vs/workbench/services/accessibility/common/accessibleViewInformationService.js';
import { IAccessibilityService } from 'vscode/vscode/vs/platform/accessibility/common/accessibility.service';
import { AccessibilityService } from 'vscode/vscode/vs/platform/accessibility/browser/accessibilityService';
import { registerAssets } from 'vscode/assets';
import './vscode/src/vs/workbench/contrib/accessibility/browser/accessibility.contribution.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/accessibility/accessibility.js';
import './vscode/src/vs/workbench/contrib/accessibilitySignals/browser/accessibilitySignal.contribution.js';

registerAssets(audioAssets);
function getServiceOverride() {
    return {
        [( IAccessibleViewService.toString())]: new SyncDescriptor(AccessibleViewService, [], true),
        [( IAccessibilitySignalService.toString())]: new SyncDescriptor(AccessibilitySignalService, [], true),
        [( IAccessibilityService.toString())]: new SyncDescriptor(AccessibilityService, [], true),
        [( IAccessibleViewInformationService.toString())]: new SyncDescriptor(AccessibleViewInformationService, [], true)
    };
}

export { getServiceOverride as default };
